/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AutomationsInputs */

const en_nav_automations = /** @type {(inputs: Nav_AutomationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automations`)
};

const es_nav_automations = /** @type {(inputs: Nav_AutomationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatizaciones`)
};

/**
* | output |
* | --- |
* | "Automations" |
*
* @param {Nav_AutomationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_automations = /** @type {((inputs?: Nav_AutomationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AutomationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_automations(inputs)
	return es_nav_automations(inputs)
});